import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'

export interface SectionHeaderProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
  className?: string
}

/**
 * SectionHeader - Displays a section title with optional subtitle and action
 * Reusable header component for dashboard sections
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, action, className = '' }) => {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1.5
      }}
    >
      <Box>
        <Box
          component="h3"
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: INTERAX_COLORS.white,
            mb: subtitle ? 0.5 : 0
          }}
        >
          {title}
        </Box>
        {subtitle && (
          <Box
            component="p"
            sx={{
              fontSize: '14px',
              color: INTERAX_COLORS.typographyFont
            }}
          >
            {subtitle}
          </Box>
        )}
      </Box>
      {action && <Box>{action}</Box>}
    </Box>
  )
}
